import { getPersistentVolumeClaim } from '@/pages/clusters/pages/Workload/api/volume.api';
import { WorkloadFetch } from '@/pages/clusters/pages/Workload/constants';
import get from 'lodash/get';
import { useEffect, useState } from 'react';
import useSWR from 'swr';

interface PersistentVolumeClaim {
  value: string;
  label: string;
  namespace: string;
  accessModes: string[];
  storage: string;
}

export const usePersistentVolumeClaims = (cluster: string, namespace: string) => {
  const shouldFetch = cluster && namespace;
  const [options, setOptions] = useState<PersistentVolumeClaim[]>([]);

  const { data: response, isLoading } = useSWR(
    !shouldFetch ? null : { key: WorkloadFetch.PERSISTENT_VOLUME_CLAIM, cluster, namespace },
    ({ cluster, namespace }) => getPersistentVolumeClaim(cluster, { namespace }),
  );

  useEffect(() => {
    if (response) {
      const { totalItems, items } = response;
      if (totalItems > 0) {
        const pvcOptions = items.map((item) => ({
          value: get(item, 'metadata.name'),
          label: get(item, 'metadata.name'),
          namespace: get(item, 'metadata.namespace'),
          accessModes: get(item, 'spec.accessModes'),
          storage: get(item, 'status.capacity.storage'),
        }));
        setOptions(pvcOptions);
      }
    }
  }, [response]);

  return { options, isLoading };
};
